import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LogoutIcon } from '@/assets/icons/LogoutIcon';
import { useSignOut } from '@/core/auth/_hooks/useSignOut';
import { useIdToken } from '@/core/store/auth/authSelectors';

import { logoutButtonStyles as sx } from './LogoutButton.styles';

type Props = {
	noAutoSpacing?: boolean;
};

export const LogoutButton = ({ noAutoSpacing = false }: Props) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobileDevice = useMediaQuery(theme.breakpoints.down(650)); // Intentional hardcoded number as breakpoint
	const style = sx.button(noAutoSpacing);
	const idToken = useIdToken();
	const { handleSignOut } = useSignOut();

	const isLoggedIn = idToken;

	const handleLogout = useCallback(async () => {
		await handleSignOut();
	}, [handleSignOut]);

	if (!isLoggedIn) {
		return null;
	}

	return isMobileDevice ? (
		<IconButton aria-label={t('Logout')} sx={style} onClick={handleLogout}>
			<LogoutIcon />
		</IconButton>
	) : (
		<Button
			endIcon={<LogoutIcon />}
			aria-label={t('Logout')}
			sx={style}
			onClick={handleLogout}
		>
			{t('LOGOUT')}
		</Button>
	);
};
